import { useTranslations } from "@zapier/i18n";

import {
  BetaDataTableCell as Cell,
  BetaDataTableRow as Row,
  SkeletonBlock,
  SkeletonText,
  VisuallyHidden,
} from "@zapier/design-system";

import styles from "./Table.module.css";

interface RowLoaderProps {
  columns: number;
  rows?: number;
  showCheckboxes?: boolean;
  showOptions?: boolean;
  showOwner?: boolean;
  showShareButton?: boolean;
}

const RowLoader = ({
  columns,
  rows = 1,
  showOptions,
  showOwner,
  showCheckboxes,
  showShareButton,
}: RowLoaderProps) => {
  const t = useTranslations("table-row-loader");
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => {
        return (
          <Row id={`row-loader-${index}`} key={index}>
            {showCheckboxes && (
              <Cell className={styles.checkboxCell}>
                <SkeletonBlock height={24} width={24} borderRadius="medium" />
              </Cell>
            )}
            <Cell className={styles.titleCell}>
              <SkeletonText lines={1} />
              <VisuallyHidden>{t("accessibility.loading-row")}</VisuallyHidden>
            </Cell>
            {Array.from({ length: columns }).map((_, index) => {
              return (
                <Cell key={index}>
                  <SkeletonText lines={1} />
                </Cell>
              );
            })}
            {showOwner && (
              <Cell className={styles.ownerCell}>
                <SkeletonBlock height={24} width={25} borderRadius="medium" />
              </Cell>
            )}
            {showOptions && (
              <Cell
                className={`${styles.iconButtonCell} ${showShareButton ? styles.hasShareButton : ""}`}
              >
                <SkeletonBlock height={25} width="100%" />
              </Cell>
            )}
          </Row>
        );
      })}
    </>
  );
};

export default RowLoader;
